import { useAuth } from '@stores';
import { Grid } from '@uikit';
import { FC, ReactNode } from 'react';
import { Footer } from '../Footer/Footer';
import { Header } from '../Header/Header';
import { Navigation } from '../Navigation/Navigation';
import classes from './layout.module.scss';

type LayoutProps = {
  children: ReactNode;
};

const Layout: FC<LayoutProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  return (
    <div className={classes.root}>
      <Header />
      <Navigation />
      <Grid.Container component="main" className={classes.layout_container}>
        {isAuthenticated && children}
      </Grid.Container>

      <Footer />
    </div>
  );
};

export default Layout;
